<template>
    <div role="form">
        <b-alert variant="danger" :show="showError" class="mb-3">
            <ul class="mb-0">
                <li v-for="(error, prop) in errors" :key="prop">
                    {{ error[0] }}
                </li>
            </ul>
        </b-alert>

        <b-form-group
            id="input-group-email"
            label="Email address:"
            label-for="email-address"
            description="We'll never share your email with anyone else."
        >
            <b-form-input
                id="email-address"
                v-model="form.email"
                type="email"
                placeholder="Enter email"
                required
            ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-name" label="Your Full Name:" label-for="input-name">
            <b-form-input
                id="input-name"
                v-model="form.name"
                placeholder="Enter your name"
                required
            ></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-password"
            label="Password:"
            label-for="input-password"
            description="Minimum of 8 characters.">
            <b-form-input
                type="password"
                id="input-password"
                v-model="form.password"
                required
            ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-password-confirm" label="Confirm Password:" label-for="input-password-confirm">
            <b-form-input
                type="password"
                id="input-password-confirm"
                v-model="form.password_confirmation"
                required
            ></b-form-input>
        </b-form-group>


        <b-form-group id="input-group-is_marketing_opt_in" label="Are you happy to receive marketing communications from us?" label-for="is_marketing_opt_in">
            <b-form-checkbox
                id="is_marketing_opt_in"
                v-model="form.is_marketing_opt_in"
                name="is_marketing_opt_in"
                value="1"
            >Yes</b-form-checkbox>
        </b-form-group>

        <b-button type="submit" variant="primary" @click="onSubmit" :disabled="isBusy">Register</b-button>

        <hr>

        <p>Already have an account?  No problem, just <a :href="'/login?return=' + currentLocation">log in</a>.</p>
    </div>
</template>

<script>
    export default {
        props: {
            session: {
                type: Object,
                required: false,
            },
            vodCourse: {
                type: Object,
                required: false,
            },
            exam: {
                type: Object,
                required: false,
            },
            return: {
                type: String,
                required: false,
            }
        },

        data() {
            return {
                form: {
                    email: '',
                    name: '',
                    password: '',
                    password_confirmation: '',
                    is_marketing_opt_in: '1',
                },
                isBusy: false,
                showError: false,
                errors: '',
            }
        },

        mounted() {

        },

        computed: {
            currentLocation: function () {
                return location.href;
            },
        },

        methods: {
            /**
             * Handle form submission
             */
            onSubmit() {
                this.isBusy = true;
                this.error = '';
                this.showError = false;

                let url = '/register';
                if(this.return) {
                    url = url + '?return=' + this.return;
                }

                axios.post(url, {
                    name: this.form.name,
                    email: this.form.email,
                    password: this.form.password,
                    password_confirmation: this.form.password_confirmation,
                    is_marketing_opt_in: this.form.is_marketing_opt_in,
                    artist_session_tag: this.session ? (this.session.intercom_tag ?? null) : null,
                    vod_course_tag: this.vodCourse ? (this.vodCourse.analytics_tag ?? null) : null,
                }).then((response) => {
                    // The form was pushed
                    if(response.data.errors) {
                        this.handleErrors(response);
                    } else {
                        // Successful, fire an event.  We should be hooking into this elsewhere to then hide this component
                        Bus.$emit('userRegistered', response.data);
                    }
                }).catch((error) => {
                    if (error.response) {
                        let response = error.response;
                        this.handleErrors(response);
                    }
                });
            },

            /**
             * Handle errors
             */
            handleErrors(response) {
                console.log(response.data.errors);
                this.errors = response.data.errors;
                this.showError = true;
                this.isBusy = false;
            },
        }
    }
</script>
